import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { ResourceType } from 'js/social/shared/types';

export const reportResource = async (
  resourceId: number | string,
  resourceType: ResourceType,
  reason?: string,
) => {
  const response = await fetchWithCsrf(
    routes.api_v0_community_report_index_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        social_item_id: resourceId,
        social_item_type: resourceType,
        reason: 'other',
        free_text_reason: reason,
      }),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to report post');
  }
  return await response.json();
};

export const deleteResourceReport = async (reportId: number | string) => {
  const response = await fetchWithCsrf(
    routes.api_v0_community_report_path({
      id: reportId,
      subdomain_param: 'api',
    }),
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: reportId,
      }),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to report post');
  }
};
